import { render } from "./NoCookiesIndicator.vue?vue&type=template&id=05cdc993&scoped=true"
import script from "./NoCookiesIndicator.vue?vue&type=script&lang=js"
export * from "./NoCookiesIndicator.vue?vue&type=script&lang=js"

import "./NoCookiesIndicator.vue?vue&type=style&index=0&id=05cdc993&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05cdc993"]])

export default __exports__